import {match} from 'ts-pattern';

import {LeasingTargetGroup} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

export function getLeasingTargetGroupLabel(targetGroup: LeasingTargetGroup) {
  return match(targetGroup)
    .with('PRIVATE', () => i18n.t('page.vehicle.financingAndLeasing.private'))
    .with('COMMERCIAL', () => i18n.t('page.vehicle.financingAndLeasing.commercial'))
    .with('BOTH', () => i18n.t('page.vehicle.financingAndLeasing.both'))
    .exhaustive();
}
